<template>
  <main-layout>
    <div slot="left-side">
      <menubar screenIdParam="M-13-17"></menubar>
    </div>

    <el-row slot="header">
      <head-title class="cancel-width">
        <!-- <label slot="title">{{ result.roomReservationDetail.title }}</label> -->

        <label slot="title"> {{$t('label.router.reservationOpen')}}</label>
        <narrow-down
          v-if="this.$authCodeCheck('020307')"
          @click="openReserve"
          slot="cancel"
        >
          {{ '予約内容編集'}}
        </narrow-down>
        <narrow-down
          v-if="this.$authCodeCheck('020306') && this.result.roomReservationDetail.status == '01'"
          @click="forcedCancel"
          slot="create"
        >
          {{ $t("button.meeting.reservation.confirm.forcedCancel") }}
        </narrow-down>
      </head-title>
    </el-row>

    <!-- ページ本体 開始 -->
    <div slot="body">
       <!-- タイトル  開始  -->
      <div class="main-title">
        {{ result.roomReservationDetail.title }}
      </div>
      <!-- タイトル 終  -->

      <!-- 情報照会 開始-->
      <div class="fist_col">

        <el-row type="flex" align="middle">
          <img :src="icon_time" alt="" />
          <label class="m-left-1 label lb3">
            {{ result.roomReservationDetail.startDate }}
            <span v-if="!result.roomReservationDetail.allDayFlag">
              {{ result.roomReservationDetail.startTime }} 〜
              {{ result.roomReservationDetail.endDate }}
              {{ result.roomReservationDetail.endTime }}
            </span>
            <span v-else class="m-left-1 end-day-class">{{ $t("label.meeting.reservation.confirm.allDayFlag") }}</span>
          </label>

        </el-row>

        <!-- <div class="cancle_date_box m-bottom-2">
          <label class="font-size-11 ">
            キャンセル可能時間：
            {{ result.roomReservationDetail.startDate }}
            {{ result.roomReservationDetail.startTime }}
          </label>
        </div> -->

        <!-- 終日展示 -->
        <!-- No.184 -->
        <!-- <div class="all_day_box m-bottom-2">
          <label class="all_day_title">
            {{ $t("label.meeting.reservation.confirm.allDayFlag") }}
          </label>
          <el-switch v-model="result.roomReservationDetail.allDayFlag" disabled>
          </el-switch>
        </div> -->

        <el-row type="flex" align="middle">
          <img :src="icon_local" alt="" />
          <label class="m-left-1 label lb3">
            {{ result.roomDetail.floorName }}
            {{ result.roomDetail.areaName }}
            {{ result.roomDetail.name }}
          </label>
        </el-row>
        <div class="cancle_date_box m-bottom-2">
          <label class="font-size-11">
            {{ result.roomDetail.buildingName }}
          </label>
        </div>

        <el-row type="flex" align="middle" class="m-bottom-2">
            <img :src="icon_lock" alt="" />
          <label
            v-if="result.roomReservationDetail.publicFlag"
            class="m-left-1">
            {{ $t("label.meeting.reservation.confirm.publicFlag") }}
          </label>
          <label v-else class="m-left-1">
            {{ $t("label.meeting.reservation.confirm.noPublicFlg") }}
          </label>
        </el-row>

        <!-- 通知時間 -->
        <el-row type="flex" align="middle" class="m-bottom-2">
          <img :src="icon_bell" alt="" />
            <label v-if="this.result.roomReservationDetail.alarmTime != ''" class="m-left-1">
                {{ result.roomReservationDetail.alarmTime }}
                <label v-if="result.roomReservationDetail.alarmTime!='通知しない'">分前</label>
            </label>
            <label v-else class="m-left-1">アラーム</label>
        </el-row>

        <el-row type="flex" align="middle" class="m-bottom-2">
          <img :src="icon_repeat" alt="" />
          <label class="m-left-1"> 繰り返し: {{result.roomReservationDetail.repeatFormula}}</label>
        </el-row>

        <el-row type="flex" align="top" class="m-bottom-2">
          <img :src="icon_detail" class="invitation-img-type" />
          <linked-text-area class="m-left-1 linke-type" :value="result.roomReservationDetail.invitation" />
        </el-row>

        <!-- 予約オプション -->
        <!-- <el-row type="flex" align="top" class="option-style">
          <img :src="option_icon" class="invitation-img-type" />
          <label class="m-left-1"> 予約オプション</label>
        </el-row>

        <div style="margin-bottom: 24px; margin-left: 32px;">
          <div class="content-style">
            {{ result.optionTitle }}
          </div>
          <div v-if="result.optionRemark != null && result.optionRemark != ''">
            <span class="answer-style" style="white-space: pre-line;" >
              {{ result.optionRemark }}
            </span>
          </div>
        </div> -->

        <!-- <div  v-for="(item,index) of result.option" :key="index" style="margin-bottom: 24px; margin-left: 32px; min-height: 66px;" v-show="!(!result.commonShowFlag && item.commonFlag)">
          <div class="content-style">
            {{ item.content }}
            <span v-if="item.mustFlag" :class="item.mustFlag ? 'master-start' : ''">
              {{ '*' }}
            </span>
          </div>

          <div v-for="(t, i) of item.answerChoiceList" :key="i">
            <span v-if="t.answer != null && t.answer != ''">{{ t.answer }}</span>
            <span class="answer-style" v-if="t.otherFlag && t.otherContent != null">{{ ': '}}</span>
            <span class="answer-style" style="width:90%;" v-if="t.otherFlag && t.otherContent != null">
              {{ t.otherContent }}
            </span>
            <span style="white-space: pre-line;" v-if="item.inputMode == '01'">
              {{ t.answerContent }}
            </span>
          </div>
        </div> -->
      </div>

      <div class="participant_box">
        <el-row class="m-bottom-2" type="flex" align="middle">
          <img :src="icon_urge_flg" alt="" class="img-type" />
          <label style="margin-left:4px">主催者</label>
        </el-row>

        <div
          v-for="(item, index) in organizerList"
          :key="'organizerList'+index" class="gust-type">
          <el-row type="flex" align="middle" >
            <div class="float-left image-type">
              <so-smart-user-image
                :src="item.url.url">
              </so-smart-user-image>
            </div>

            <div class="float-left m-left-1">
              <div class="nameEmail-width">{{ item.organizerName }}</div>
              <div class="font-email font-lato">
                {{ item.organizerEmail}}
              </div>
            </div>
          </el-row>
        </div>


        <el-row class="m-bottom-2" type="flex" align="middle" v-show="participantIsShow">
          <img :src="icon_urge_flg" alt="" class="img-type" />
          <label style="margin-left:4px">参加者</label>
        </el-row>
        <div
          v-for="(item, index) in participantList"
          :key="'participantList'+index" class="gust-type">
          <el-row type="flex" align="middle" >
            <div class="float-left image-type">
              <so-smart-user-image
                :src="item.portrait.url">
              </so-smart-user-image>
            </div>

            <div class="float-left m-left-1">
              <div class="nameEmail-width">
                <div style="display: flex;">
                  <div class="nameEmail-width">
                    {{ item.fullname }}
                  </div>
                  <div style="display: flex;align-items: center;">
                    <div v-show="!item.participationRequiredFlag" class="RequiredFlag">{{"任意"}}</div>
                  </div>
                </div>
                <!-- 2021/06/30IES孙YL変更5-1 -->
              </div>
              <div class="font-email font-lato">
                {{ item.email }}
              </div>
              <div class="font-companyName">
                {{ item.companyName }}
              </div>
            </div>

          </el-row>
        </div>

        <el-row class="m-bottom-2" type="flex" align="middle" v-show="guestIsShow">
          <img :src="icon_urge_flg" alt="" class="img-type" />
          <label style="margin-left:4px">ゲスト</label>
        </el-row>

        <div
          v-for="(item, index) in guestList"
          :key="'guestList'+index" class="gust-type">
          <el-row type="flex" align="middle" >
            <div class="float-left image-type">
              <so-smart-user-image
                :src="item.url.url">
              </so-smart-user-image>
            </div>

            <div class="float-left m-left-1">
              <div class="nameEmail-width">
                <div style="display: flex;">
                  <div class="nameEmail-width">
                    {{ item.guestName }}
                  </div>
                  <div style="display: flex;align-items: center;">
                    <div v-show="!item.participationRequiredFlag" class="RequiredFlag">{{$t('任意')}}</div>
                  </div>
                </div>
                <!-- 2021/06/30IES孙YL変更5-1 -->
              </div>
              <div class="font-email font-lato">
                {{ item.guestEmail }}
              </div>
              <div class="font-companyName">
                {{ item.guestCompanyname }}
              </div>
            </div>
          </el-row>
        </div>

      </div>

      <el-dialog-prompt
        :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
        :msgParam="msgParam"
        @on-isPassParam="isPassParam">
      </el-dialog-prompt>

    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/NewDesignLayout";
import SystemManageApi from "@/api/SystemManageApi";
import { weeksAll } from "@/utils/parse-date";
import errorCodeMsg from "@/utils/error-code-msg"
import headTitle from "@/components/common/head/head";
import narrowDown from "@/components/common/sp-smart-button";
import Menubar from "@/components/leftmenu/Home";
import { hearderRebellion } from "@/utils/outlookCodeconversionUtils"
import SoSmartUserImage from "@/components/common/so-smart-user-image/AuthImage";
// import moment from "moment";
import elDialogPrompt from "@/components/common/el-dialog-prompt"
import LinkedTextArea from "@/components/common/sp-textarea/LinkedTextArea";
import Configuration from "@/config/index"

export default {
  name: "MeetingReservationConfirm",
  components: {
    LinkedTextArea,
    MainLayout: MainLayout,
    headTitle: headTitle,
    Menubar: Menubar,
    narrowDown: narrowDown,
    SoSmartUserImage,
    elDialogPrompt
  },
  data() {
    return {
      participantIsShow:false,
      guestIsShow:false,
      centerDialogVisibleIsShow:false,
      msgParam:null,
      // icon圖標
      icon_time: require("@/assets/icon/sp-icon-time.svg"),
      icon_local: require("@/assets/icon/sp-icon-menu.svg"),
      icon_lock: require("@/assets/icon/sp-icon-lock.svg"), //
      icon_bell: require("@/assets/icon/sp-icon-bell.svg"),
      icon_repeat: require("@/assets/icon/sp-icon-repeat.svg"),
      icon_detail: require("@/assets/icon/sp-icon-detail.svg"),
      option_icon: require("@/assets/icon/option_icon.svg"),
      // 朱催者右下角圖標
      icon_urge_flg: require("@/assets/icon/sp-icon-urge-flg.svg"),
      listData: [1, 2, 3, 5, 6, 7],
      result: {
        roomReservationDetail: {
          tenantName: null, //予約テナント名
          name: null, //予約者名
          title: null, //会議タイトル
          allDayFlag: null, //終日フラグ
          startDate: null, //開始日
          startTime: null, //開始時間
          endTime: null, //終了時間
          alarmTime: null, //通知時間
          repeatFormula: null, //繰り返し情報
          invitation: null, //招待文言
          publicFlag: null, //公開設定フラグ
          status: null,
          pageShowTime: null,
        },
        roomDetail: {
          buildingName: null, //ビル名
          floorName: null, //フロア名
          areaName: null, //エリア名
          name: null, //会議室名
          cancelEnableTime: 0 //キャンセル可能時間
        },
        optionTitle:null,
        optionRemark:null,
        commonShowFlag:false,
        option:[]
      },
      year: null,
      month: null,
      date: null,
      reserveId: null, //予約ID
      // 参与者信息列表，根据主催者表示排序
      organizerList: [
      ],
      participantList: [
      ],
      guestList: [
      ],
    };
  },
  created() {
    this.reserveId = this.$route.params.reserveId;
    this.initBread();
  },
  methods: {
    //
    hearderRebellion,
    weeksAll,

    isPassParam(param){
      if(param){
        SystemManageApi.OutlookMeetingRoomRezForceCance(this.reserveId)
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          if (data.statusCode == 'Success') {
            this.forceCancelSuccess();
            this.goToReservationConfirmationOrOpenTop();
          }
        })
      }
    },

    forcedCancel() {
      this.msgParam = this.$t("message.common.forceCancelMsgBox"),
      this.centerDialogVisibleIsShow = true
    },
    //强制取消Message
    forceCancelSuccess: function () {
      this.$messageIotSuccess(this.$t("message.common.forceCancelMessage"));
    },
    //「ダッシュボード」画面に遷移する
    goToDashboard() {
      this.$router.push({
        name: "",
      });
    },
    //「予約確認／開放トップ」画面に遷移する
    goToReservationConfirmationOrOpenTop() {
      this.$router.push({
        name: "system-reservation-outlook-open",
      });
    },
    formatEndDate(startDate, endDate) {
      if (!startDate || !endDate) return "";

      if (startDate === endDate) return "";

      const s = new Date(startDate);
      const e = new Date(endDate);

      const week = ["日", "月", "火", "水", "木", "金", "土"];

      const sMonth = s.getMonth() + 1;
      const eMonth = e.getMonth() + 1;
      const eDay = e.getDate();
      const eWeek = week[e.getDay()];

      if (sMonth === eMonth) {
        return `${eDay}日`;
      }

      return `${eMonth}月${eDay}日（${eWeek}）`;
    },

    OutlookMeetingRoomRezDetailPage() {
      if (this.reserveId == "") {
        this.goToDashboard();
      } else {
        SystemManageApi.OutlookMeetingRoomRezDetailPage(this.reserveId)
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(
          ({ data }) => {
            if (data.body.length == 0) {
              this.$msgbox({
                message: this.$t("message.common.validation.notExist", {
                  field: this.$t(
                    "label.meeting.reservation.confirm.meetingReservation"
                  ),
                }),
                showClose: false,
                confirmButtonText: this.$t("button.common.ok"),
              });
              this.goToReservationConfirmationOrOpenTop();
            } else {
              this.result.roomDetail = data.body.roomDetail;
              this.result.roomReservationDetail.tenantName = data.body.reservationDetail.tenantName;
              // this.result.roomReservationDetail.name = data.body.reservationDetail.name;
              this.result.roomReservationDetail.title = data.body.reservationDetail.title;
              this.result.roomReservationDetail.allDayFlag = data.body.reservationDetail.allDayFlag;
              this.result.roomReservationDetail.startDate = this.$dateFormat(new Date(data.body.reservationDetail.startDate));
              this.result.roomReservationDetail.endDate = this.formatEndDate(data.body.reservationDetail.startDate,data.body.reservationDetail.endDate)
              if(data.body.reservationDetail.startTime) {
                this.result.roomReservationDetail.startTime = data.body.reservationDetail.startTime.substring(0,5);
              }
              if(data.body.reservationDetail.endTime) {
                this.result.roomReservationDetail.endTime = data.body.reservationDetail.endTime.substring(0,5);
              }

              if(data.body.reservationDetail.alarmTime!=null && data.body.reservationDetail.alarmTime!=undefined ){
                this.result.roomReservationDetail.alarmTime = data.body.reservationDetail.alarmTime;
              }else{
                this.result.roomReservationDetail.alarmTime = "通知しない"
              }

              this.result.roomReservationDetail.invitation = data.body.reservationDetail.invitation;
              this.result.roomReservationDetail.publicFlag = data.body.reservationDetail.publicFlag;
              this.result.roomReservationDetail.status = data.body.reservationDetail.status;
              let repeatFormulaObj = data.body.reservationDetail.repeatFormula ;
              let endDate = new Date(repeatFormulaObj.endDate);
              this.year = endDate.getFullYear();
              this.month = endDate.getMonth() + 1;
              this.date = endDate.getDate();
              this.result.roomReservationDetail.repeatFormula = hearderRebellion(repeatFormulaObj,this);
              // this.result.optionTitle = data.body.roomDetail.reserveOption.optionTitle;
              // this.result.optionRemark = data.body.roomDetail.reserveOption.optionRemark;
              // this.result.commonShowFlag = data.body.roomDetail.reserveOption.commonShowFlag;
              let option = []
              //予約オプション情報取得
              if(data.body.roomDetail.reserveOption != null && (data.body.roomDetail.reserveOption.optionDetailList != undefined && data.body.roomDetail.reserveOption.optionDetailList != null && data.body.roomDetail.reserveOption.optionDetailList.length > 0)){
                for(let optionDetail of data.body.roomDetail.reserveOption.optionDetailList){
                  let answerChoiceList = []
                  // 予約質問回答取得
                  // if(data.body.reservationDetail.optionAnswerDetailList != null && data.body.reservationDetail.optionAnswerDetailList.length > 0){
                  //   for(let optionAnswer of data.body.reservationDetail.optionAnswerDetailList ){
                  //     if(optionAnswer.detailId == optionDetail.detailId){
                  //       if(optionDetail.choiceList != null && optionDetail.choiceList.length > 0){
                  //         for(let choice of optionDetail.choiceList){
                  //           let answer = null
                  //           let otherContent = null
                  //           let answerContent = null
                  //           for(let answerChoiceId of optionAnswer.choiceIdList){
                  //             if(choice.choiceId == answerChoiceId){
                  //               if(optionDetail.inputMode != '01' ){
                  //                 answer = choice.choiceContent
                  //                 if(choice.otherFlag){
                  //                   otherContent = optionAnswer.answerContent
                  //                 }
                  //               }else{
                  //                 answerContent = optionAnswer.answerContent
                  //               }
                  //             }
                  //           }
                  //           answerChoiceList.push({
                  //             answer:answer,
                  //             otherFlag:choice.otherFlag,
                  //             otherContent:otherContent,
                  //             answerContent:answerContent
                  //           })
                  //         }
                  //       }else if(optionDetail.inputMode == '01'){
                  //         answerChoiceList.push({
                  //             answer:null,
                  //             otherFlag:false,
                  //             otherContent:null,
                  //             answerContent:(optionAnswer.choiceIdList != null && optionAnswer.choiceIdList.length > 0) || (optionAnswer.choiceIdList.length == 1 && optionAnswer.choiceIdList[0] != null) ? null :optionAnswer.answerContent
                  //           })
                  //       }

                  //     }
                  //   }
                  // }

                  let content = null
                  if(optionDetail.inputMode == '01'){
                    content = optionDetail.content + '（自由入力）'
                  }else if(optionDetail.inputMode == '02' || optionDetail.inputMode == '04'){
                    content = optionDetail.content + '（１つ選択）'
                  }else{
                    content = optionDetail.content + '（複数回答可）'
                  }
                  option.push({
                    commonFlag:optionDetail.commonFlag,
                    content:content,
                    inputMode:optionDetail.inputMode,
                    mustFlag:optionDetail.mustFlag,
                    maxLength:optionDetail.optionDetail,
                    answerChoiceList:answerChoiceList
                  })
                }
              }
              this.result.option = []
              this.result.option = option

              if( data.body.reservationDetail.participantList != null || data.body.reservationDetail.participantList != undefined ){
                //参加者情報取得
                for(let index of data.body.reservationDetail.participantList) {
                  let img = []
                  if (index.urgeFlag) {
                    if (index.portrait != null) {
                      img.id = index.portrait.id,
                      img.url = this.$GetImageUrl(index.portrait.url)
                    }
                    this.organizerList.push({
                      organizerName: index.fullname,
                      organizerEmail: index.email,
                      tenantName: index.companyName,
                      url: img,
                      participationRequiredFlag: index.participationRequiredFlag // 2021/06/30IES孙YL変更5-1
                    })
                  } else if (index.guestFlag) {
                    if (index.portrait != null) {
                      img.id = index.portrait.id,
                      img.url = this.$GetImageUrl(index.portrait.url)
                    }
                    this.guestList.push({
                      guestName: index.fullname,
                      guestEmail: index.email,
                      guestCompanyname: index.companyName,
                      url: img,
                      participationRequiredFlag: index.participationRequiredFlag
                    })
                  } else {
                    if (index.portrait != null) {
                      img.id = index.portrait.id,
                      img.url = this.$GetImageUrl(index.portrait.url)
                    }
                    this.participantList.push({
                      fullname: index.fullname,
                      email: index.email,
                      companyName: index.companyName,
                      portrait: img,
                      participationRequiredFlag: index.participationRequiredFlag
                    })
                  }
                }
                if (this.participantList.length > 0) {
                  this.participantIsShow = true;
                }
                if (this.guestList.length > 0) {
                  this.guestIsShow = true;
                }
              }
              this.$forceUpdate();
            }

          }
        );
      }
    },
    /**
     * 根据主催者排序
     */
    sortParticipantList(array) {
      array.sort((a, b) => b.urgeFlag - a.urgeFlag);
      return array;
    },
    /**
     * ブレッドクラムを初期化する
     */
    initBread() {
      let breadcrumb = [
        {
          path: "/",
          title: "label.router.home",
        },

        {
          path: "/system/reservation/outlook/open",
          title: "label.router.reservationOpen",
        },
        {
          path: "",
          title: "label.router.reservationDetails",
        },
      ];
      this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);
    },
    openReserve(){
      let url = Configuration['public.app.url'] + '/noticeRedirect.html?noticeType=0902&uuid=' + this.reserveId
      window.open(url, '_blank')
    },
  },
  mounted() {
    this.OutlookMeetingRoomRezDetailPage();
  },
};
</script>

<style scoped lang="scss">
::v-deep .cancel-width{
  .my-button{
    height: 32px;
  }
}
.el-button {
  cursor: default;
}
.my-button{
  background-color: #F7F7F2
}
.fist_col {
  width: 460px;
  height: 364px;
  float: left;
  font-size: 14px;
  color: #525250;
}
.avatar_box {
  float: left;
  height: 50px;
  width: 50px;
  border-radius: 50%;
  padding: 1px;
  position: relative;
  left: 50px;
}
.account_img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.detail_box {
  margin-left: 10px;
}
.all_day_box {
  padding-left: 36px;
}
.all_day_title {
  font-size: 16px;
  margin-right: 15px;
}

.repeat_formula_title {
  position: relative;
  bottom: 9px;
  left: -5px;
}
.repeat_formula_content {
  padding-top: 14px;
}

.pulic_title {
  position: relative;
  bottom: 5px;
  left: -8px;
}
.alaram_time_box {
  height: 50px;
}
.alarm_time_title {
  position: relative;
  bottom: 30px;
  left: 38px;
}
.alarm_time_begin {
  margin-left: 20px;
}
.alarm_time_value {
  position: relative;
  left: 8px;
  bottom: 3px;
}

.detail_title {
  width: 300px;
  margin-left: 10px;
  // position: relative;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
}

.begin_date_title {
  height: 40px;
  position: relative;
  bottom: 9px;
  left: -9px;
}
// No.109
.cancle_date_box {
  padding-left: 36px;
}
.local_info_box {
  margin-top: 10px;
}
.local_build_box {
  position: relative;
  bottom: 12px;
  left: 47px;
}
.participant_box {
  float: left;
  background-color: #f7f7f2;
  width: 256px;
  height: auto;
  min-height: 350px;
  border-radius: 10px;
  margin-left: 84px;
  font-size: 14px;
  color: #525250;
  padding-top: 27px;
  padding-left: 20px;
  padding-bottom: 40px;
  padding-right: 20px;
  box-shadow: -2px -2px 4px #FFFFFA,
            4px 4px 4px #E6E6D8;
}
// No.109
.font-size-11 {
  font-size: 11px;
}
.nameEmail-width {
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  width: 155px;
}
.font-email {
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  font-size: 11px !important;
  width: 155px;
}

.m-bottom-2{
  margin-bottom: 20px !important;
}
/* No.184 */
.end-day-class{
  margin-left: 20px;
}

.image-type {
  margin-left: 22px;
}

.gust-type {
  margin-bottom: 16px;
}
.gust-type:nth-last-child(1) {
  margin-bottom: 0px;
}

::v-deep .label {
  line-height: 20px;
}

.img-type {
  width: 18px;
  height: 18px;
}

.invitation-img-type {
  width: 28px;
  height: 28px;
}

::v-deep .sp-textarea {
  padding: 0px;
}

.linke-type {
  line-height: 28px;
}

.flagclass {
  border: 1px solid black
}

.RequiredFlag {
  background: #DEDED9;
  border-radius: 2px;
  text-align: center;
  font-size: 9px;
  line-height: 17px;
  color: #858582;
  margin-left: 9px;
  float: right !important;
  width: 52px;
  height: 15px;
}

.font-companyName{
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  width: 155px;
}
.master-start {
  color: #F56C6C;
}
.option-style{
  align-items: center;
  font-size: 16px;
  font-weight: 300;
  margin-bottom: 24px;
}
.content-style{
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
}
</style>
